var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkModeSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3411 12.7414C18.2455 12.6541 18.1053 12.6369 17.9911 12.6972C14.722 14.4311 10.7101 13.2778 8.85899 10.0715C7.00787 6.86513 8.01457 2.81459 11.1509 0.84991C11.2605 0.781365 11.3152 0.651089 11.2874 0.524942C11.2597 0.398588 11.1557 0.303204 11.0274 0.286893C8.99525 0.0257211 6.98288 0.429764 5.20671 1.45546C3.05828 2.69525 1.52139 4.69833 0.879303 7.09471C0.237212 9.4911 0.566723 11.994 1.80734 14.1426C3.04775 16.2913 5.05062 17.8282 7.44701 18.4703C8.24725 18.6846 9.05925 18.7907 9.8661 18.7907C11.4755 18.7907 13.064 18.3687 14.4949 17.5424C16.2707 16.5171 17.6271 14.9761 18.4171 13.0858C18.467 12.9664 18.4365 12.8287 18.3411 12.7414Z",
    fill: "#0A0D12"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeSvg);
export default __webpack_public_path__ + "static/media/DarkModeSvg.9ef71e85eecccf359f8f6c36c9f11d55.svg";
export { ForwardRef as ReactComponent };